import { render, staticRenderFns } from "./ShippingTicketComponent.vue?vue&type=template&id=1fcd634c&scoped=true"
import script from "./ShippingTicketComponent.vue?vue&type=script&lang=ts"
export * from "./ShippingTicketComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd634c",
  null
  
)

export default component.exports